import o from"styled-components";const e=o.div`
	& > div:first-child {
		border: none;
		box-shadow: none;

		height: 40px;
		background-color: ${({theme:o})=>o.bg.primary};
		border-radius: 8px;
		box-sizing: border-box;

		& > *:nth-child(3) {
			border-radius: 8px;
		}
	}

	.date-picker__control {
		height: 40px;
		background-color: ${({theme:o})=>o.bg.primary};
		box-sizing: border-box;
		border-top-left-radius: 8px;
		border-bottom-left-radius: 8px;
		border: none;
		width: 100%;

		&:focus {
			outline: none;
		}
	}

	.time-picker__control {
		height: 40px;
		background-color: ${({theme:o})=>o.bg.primary};
		box-sizing: border-box;
		border: none;
		width: 100%;

		&:focus {
			outline: none;
		}
	}

	.time-picker__single-value {
		color: ${({theme:o})=>o.text.input};
		font-size: 13.3333px;
	}

	.date-picker__single-value {
		color: ${({theme:o})=>o.text.input};
		font-size: 13.3333px;
	}

	svg {
		color: ${({theme:o})=>o.text.input};
	}
`;export{e as DateContainer};
